import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'app-move-item-dialog',
    templateUrl: './move-item-dialog.component.html',
    styles: [``],
    standalone: false
})
export class MoveItemDialogComponent implements OnInit {
  public moveForm: UntypedFormGroup;
  public treeItems: TreeNode[];
  public labelText: string;
  public selectedNode: TreeNode | null = null;
  public targetLevel: string;
  private itemId: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.itemId = config.data.id;
    this.targetLevel = config.data.targetLevel; // e.g., 'companies', 'projects', 'sites', 'wells', 'wellbores'
    this.labelText = config.data.labelText; // e.g., 'company', 'project', 'site', 'well', 'wellbore'
    this.treeItems = this.filterTree(config.data.treeItems, config.data.targetLevel);
  }

  ngOnInit(): void {
    this.moveForm = this.formBuilder.group({
      fromParentId: [this.config.data?.fromParentId],
      toParentId: ['', Validators.required]
    });
  }

  // Generic tree filter that keeps levels up to and including the target level
  private filterTree(nodes: TreeNode[], targetLevel: string): TreeNode[] {
    const levelOrder = ['companies', 'projects', 'sites', 'wells', 'wellbores', 'designs'];
    const targetIndex = levelOrder.indexOf(targetLevel);
    
    return nodes
      .filter(node => {
        const nodeIndex = levelOrder.indexOf(node.data.level);
        return nodeIndex <= targetIndex;
      })
      .map(node => {
        const nodeCopy = { ...node };
        if (nodeCopy.children && nodeCopy.children.length > 0) {
          nodeCopy.children = this.filterTree(nodeCopy.children, targetLevel);
        }
        return nodeCopy;
      });
  }

  onNodeSelect(node: TreeNode) {
    if(node && node.data && node.data.level === this.targetLevel){
      this.selectedNode = node;
      this.moveForm.controls['toParentId'].setValue(node.data.id);
    } else {
      this.selectedNode = null;
      this.moveForm.controls['toParentId'].setValue('');
    }
  }

  onNodeClear() {
    this.selectedNode = null;
    this.moveForm.controls['toParentId'].reset();
  }

  onSave() {
    const data = { ...this.moveForm.value, itemId: this.itemId };
    this.ref.close(data);
  }

  onCancel() {
    this.ref.close();
  }

  onInputFocus($event: Event) {
    ($event.target as HTMLInputElement).select();
  }
}
